"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ServiceWorkerNotSupported = function () { return (React.createElement("div", { className: "oidc-serviceworker" },
    React.createElement("div", { className: "oidc-serviceworker__container" },
        React.createElement("h1", { className: "oidc-serviceworker__title" }, "Unable to authenticate on this browser"),
        React.createElement("p", { className: "oidc-serviceworker__content" }, "Your browser is not secure enough to make authentication work. Try updating your browser or use a newer browser.")))); };
exports.default = ServiceWorkerNotSupported;
//# sourceMappingURL=ServiceWorkerNotSupported.component.js.map